import { FeatureGate } from '@/components/FeatureGate';
import { IS_PRODUCTION_ENVIRONMENT } from '@/config';
import { useGetStatusQuery } from '@/services/assistant/assistant';
import { FC, PropsWithChildren } from 'react';
import { useWorkspace } from '../workspaces/hooks';

type AssistantFeatureGateProps = PropsWithChildren;

export const AssistantFeatureGate: FC<AssistantFeatureGateProps> = ({ children }) => {
  const { id } = useWorkspace();
  const { data: enabled, isFetching } = useGetStatusQuery({ workspaceId: id });

  return isFetching || enabled !== true ? null : <FeatureGate feature='chat'>{children}</FeatureGate>;
};
